export const PRODUCT_DESCRIPTION_HEADING = 'Description';
export const PRODUCT_VARIATIONS_HEADING = 'Variations';
export const PRODUCT_DIMENTIONS_HEADING = 'Dimensions';
export const MADE_FROM_HEADING = 'Made from';
export const INGREDIENTS_TITLE = 'Ingredients and allergens information (PDF)';
